import {createApp} from 'vue'
import ProfileEditedOverlay from './ProfileEditedOverlay'

const el = '[data-content=ProfileEditedOverlay]'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((ProfileEditedOverlayDOM)=>{
            const profileSettingsPageUrl = ProfileEditedOverlayDOM.dataset.profileSettingsPageUrl

            Store.commit('main/set_page_overlay_content_data',{ profileSettingsPageUrl })
        })
    }
}